import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/aiSubtitled.svg'
import _imports_1 from '@/assets/newPhone/default.svg'
import _imports_2 from '@/assets/newPhone/aiSubtitles_embed.svg'


const _withScopeId = n => (_pushScopeId("data-v-016712bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = { class: "mod_c_title" }
const _hoisted_3 = { class: "mod_c_ltbody main" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "data_link" }, null, -1))
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "svg_mobile" }
const _hoisted_7 = { src: _imports_0 }
const _hoisted_8 = { class: "svg_mobile" }
const _hoisted_9 = { src: _imports_1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "embed" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1))
const _hoisted_11 = { class: "cv_img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "form_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_item_title" }, "原声语种：", -1))
const _hoisted_16 = { class: "form_item_main" }
const _hoisted_17 = { class: "form_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_item_title aligin-top translate-10" }, "字幕语种：", -1))
const _hoisted_19 = { class: "form_item_main" }
const _hoisted_20 = { class: "form_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_item_title aligin-top" }, "展示状态:", -1))
const _hoisted_22 = { class: "form_item_main" }
const _hoisted_23 = { class: "form_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form_item_title" }, "观众复制：", -1))
const _hoisted_25 = { class: "form_item_main" }
const _hoisted_26 = { class: "save" }

import { reactive, ref, computed } from 'vue';
import { Switch, Radio, message, Select, Alert } from 'ant-design-vue';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import Crumb from '@/components/Crumb.vue';
import http from '@/api';
import CUpload, { FileItem } from '@/components/CUpload.vue';
import { useLiveStore } from '@/pinia/live';
import { AiSubitObj } from '@/pinia/types/live';

interface Optiontype {
  value: number;
  label: string;
  disabled: boolean;
}

interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}
// S-上传照片

export default /*#__PURE__*/_defineComponent({
  __name: 'AiSubtitles',
  setup(__props) {

const route = useRoute();
const aSwitch = Switch;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const aSelect = Select;
const aAlert = Alert;

const pageLoading = ref(false); //开关
const studioId = route.params.studioId;
const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);

const aiSubit = reactive<AiSubitObj>({
  status: 0,
  switch: 0,
  native_language: 0,
  current_language: 0,
  caption_language: [],
  logo_switch: 0,
  logo_id: 0,
  logo_url: '',
  subtitle_archive: 0,
  allow_copying: 0,
  display_style: 0,
  caption_switch: 0,
});
const imageUrl = ref<string>('');
const provinceId = ref(''); // 图片id

const langOptions = ref<Optiontype[]>([]);
const capLangOptions = computed(() => {
  const arr: Optiontype[] = [];
  langOptions.value.forEach((item, i) => {
    arr[i] = { ...item };
    if (aiSubit.caption_language.includes(item.value)) {
      arr[i].disabled = true;
    } else {
      arr[i].disabled = false;
    }
  });
  return arr;
});
// const otherLangOptions = computed(() => langOptions.value.filter((item) =>  aiSubit.caption_language.split(',')))

const getData = () => {
  pageLoading.value = false;
  Promise.all([http.live.getCaptionLanguageList(), http.live.getMultSubtitle({ params: { studio_id: studioId } })])
    .then(([res1, res2]) => {
      const resLang = res1.data.data;
      langOptions.value = resLang.reduce((pre, crr: { id: number; language: string }) => {
        pre.push({
          value: crr.id,
          label: crr.language,
          disable: false,
        });
        return pre;
      }, [] as Optiontype[]);
      // res2
      const resSubtitle = res2.data.data;
      aiSubit.status = parseInt(resSubtitle.status);
      aiSubit.switch = parseInt(resSubtitle.switch);
      const keywordNat = parseInt(resSubtitle.native_language);
      aiSubit.native_language = keywordNat ? keywordNat : langOptions.value[0].value;
      const keywordCap = parseInt(resSubtitle.current_language);
      aiSubit.current_language = keywordCap ? keywordCap : langOptions.value[0].value;
      const capArritem = resSubtitle.caption_language.split(',').map(Number);
      aiSubit.caption_language = capArritem[0] ? capArritem : [langOptions.value[0].value];
      aiSubit.subtitle_archive = parseInt(resSubtitle.subtitle_archive);
      aiSubit.allow_copying = parseInt(resSubtitle.allow_copying);
      aiSubit.display_style = parseInt(resSubtitle.display_style);
      // aiSubit.logo_switch = parseInt(resSubtitle.logo_switch);
      aiSubit.caption_switch = parseInt(resSubtitle.caption_switch);
      imageUrl.value = resSubtitle.logo_url;
      provinceId.value = resSubtitle.logo_id;
      liveStore.aiSubitSwitch = Boolean(aiSubit.switch);
    })
    .catch((err: any) => {
      message.error(err.data.error);
    })
    .finally(() => {
      pageLoading.value = true;
    });
};

const onAddLangSelect = () => {
  const arr = langOptions.value.find((item) => !aiSubit.caption_language.includes(item.value));
  aiSubit.caption_language.push(arr ? arr.value : 2);
};
const onDelLangSelect = (data: number) => {
  if (aiSubit.caption_language.length <= 1) return;
  aiSubit.caption_language = aiSubit.caption_language.filter((item) => item !== data);
};

const fileList = ref([]);
const loading = ref<boolean>(false);
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    imageUrl.value = info.file?.response?.data.url;
    provinceId.value = info.file?.response?.data.id;
  }
  if (info.file.status === 'uploading') {
    loading.value = true;
    return;
  } else loading.value = false;
  if (info.file.status === 'error') {
    loading.value = false;
    message.error('上传失败');
  }
};
const imageDel = (info: any, keywords: number) => {
  provinceId.value = '';
  imageUrl.value = '';
};
// E-上传照片

const save = useDebounce(() => {
  if (aiSubit.caption_language.length && !aiSubit.caption_language.includes(aiSubit.current_language)) {
    aiSubit.current_language = aiSubit.caption_language[0];
  }
  http.live
    .MultSubtitle({
      studio_id: studioId,
      status: aiSubit.status,
      switch: aiSubit.switch,
      native_language: aiSubit.native_language,
      current_language: aiSubit.current_language,
      caption_language: aiSubit.caption_language.join(','),
      logo_switch: aiSubit.logo_switch,
      logo_id: provinceId.value,
      logo_url: imageUrl.value,
      subtitle_archive: aiSubit.subtitle_archive,
      allow_copying: aiSubit.allow_copying,
      display_style: aiSubit.display_style,
    })
    .then((res) => {
      message.success(res.data.message);
      liveStore.aiSubitSwitch = Boolean(aiSubit.switch);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

const init = () => {
  getData();
};
init();

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
        _createVNode(_unref(aSwitch), {
          checked: aiSubit.switch,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((aiSubit.switch) = $event)),
          checkedValue: 1,
          unCheckedValue: 0,
          style: {"margin-left":"20px"},
          onChange: _unref(save)
        }, null, 8, ["checked", "onChange"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(aAlert), {
          message: "更改语种需要在发起直播页面，重启实时字幕功能才可生效！",
          banner: "",
          class: "warn_progress"
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
              [_vShow, !aiSubit.status]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                [_vShow, aiSubit.status]
              ]),
              _hoisted_10
            ], 512), [
              [_vShow, aiSubit.status]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("img", {
                src: _unref(liveInfo).image_player_cover_url
              }, null, 8, _hoisted_12), [
                [_vShow, _unref(liveInfo).image_player_cover_url]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(aSelect), {
                  value: aiSubit.native_language,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((aiSubit.native_language) = $event)),
                  class: "ai_select",
                  options: langOptions.value
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_svg_icon, {
                      class: "mod_select_icon",
                      "icon-class": "list_select"
                    })
                  ]),
                  _: 1
                }, 8, ["value", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aiSubit.caption_language, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "select_item",
                    key: item
                  }, [
                    _withDirectives(_createVNode(_component_svg_icon, {
                      class: "select_item_del",
                      "icon-class": "delete_circular_click",
                      onClick: ($event: any) => (onDelLangSelect(item))
                    }, null, 8, ["onClick"]), [
                      [_vShow, aiSubit.caption_language.length > 1]
                    ]),
                    _createVNode(_unref(aSelect), {
                      value: aiSubit.caption_language[index],
                      "onUpdate:value": ($event: any) => ((aiSubit.caption_language[index]) = $event),
                      class: "ai_select",
                      options: _unref(capLangOptions)
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_svg_icon, {
                          class: "mod_select_icon",
                          "icon-class": "list_select"
                        })
                      ]),
                      _: 2
                    }, 1032, ["value", "onUpdate:value", "options"])
                  ]))
                }), 128)),
                _createVNode(_component_a_button, {
                  type: "link",
                  size: "large",
                  class: "cet_btn",
                  disabled: aiSubit.caption_language.length === langOptions.value.length,
                  onClick: onAddLangSelect
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(PlusCircleOutlined))
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_a_button, { type: "link" })
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(aRadioGroup), {
                  value: aiSubit.status,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((aiSubit.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(aRadio), { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("独立显示")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(aRadio), { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("嵌入视频")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_unref(aSwitch), {
                  checked: aiSubit.allow_copying,
                  "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((aiSubit.allow_copying) = $event)),
                  checkedValue: 1,
                  unCheckedValue: 0
                }, null, 8, ["checked"])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _unref(save)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ], 512), [
        [_vShow, pageLoading.value]
      ])
    ])
  ], 64))
}
}

})